import React from 'react';
import { useNavigate } from 'react-router-dom';
import { shouldShowVerifiedBadge } from '../../utils/membershipUtils';

export default function MarketplaceSellerCard({ seller, favoriteIds, onToggleFavorite, isAuthenticated }) {
  const navigate = useNavigate();
  const productCount = seller._count?.products || 0;

  const plan = seller.membershipPlan || 'Basic';
  const planLower = plan.toLowerCase();
  let badge = { label: 'Basic', color: '#6D6D6D' };
  if (planLower.includes('gcc') || planLower.includes('premium') || planLower.includes('gold')) {
    badge = { label: 'GCC Business', color: '#009D0A' };
  } else if (planLower.includes('global') || planLower.includes('enterprise') || planLower.includes('platinum')) {
    badge = { label: 'Global', color: '#FF6600' };
  }

  return (
    <article
      role="button"
      tabIndex={0}
      onClick={(e) => {
        if (e.target.closest('button')) return;
        navigate(`/seller/${seller.id}`);
      }}
      onKeyDown={(e) => e.key === 'Enter' && navigate(`/seller/${seller.id}`)}
      className="mh-seller-card mh-product-card group rounded-2xl bg-white border border-gray-100 overflow-hidden transition-all duration-300 min-w-[280px] max-w-[320px] shrink-0 snap-start shadow-[0_2px_12px_rgba(0,0,0,0.06)] hover:shadow-[0_12px_28px_rgba(0,0,0,0.1)] hover:border-orange-200/80"
    >
      <div className="h-24 overflow-hidden relative">
        <img
          src={seller.coverImage || 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600'}
          alt=""
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
      </div>
      <div className="p-4 -mt-8 relative">
        <div className="flex items-start gap-3">
          {seller.logo ? (
            <img src={seller.logo} alt="" className="w-14 h-14 rounded-full border-4 border-white object-cover shadow-md" />
          ) : (
            <div className="w-14 h-14 rounded-full border-4 border-white bg-gray-200 flex items-center justify-center font-bold text-gray-600">
              {(seller.name || 'S').charAt(0)}
            </div>
          )}
          <div className="flex-1 min-w-0 pt-6">
            <h3 className="font-bold text-b2b-ink truncate group-hover:text-b2b-orange transition-colors">{seller.name}</h3>
            <div className="flex flex-wrap gap-1 mt-1">
              <span className="text-[10px] font-semibold px-2 py-0.5 rounded-full bg-gray-50" style={{ color: badge.color }}>
                {badge.label}
              </span>
              {shouldShowVerifiedBadge(seller.membershipPlan) && (
                <span className="text-[10px] font-semibold text-sky-600 bg-sky-50 px-2 py-0.5 rounded-full">Verified</span>
              )}
            </div>
          </div>
          <button
            type="button"
            title={favoriteIds.includes(seller.id) ? 'Saved' : 'Save supplier'}
            onClick={(e) => onToggleFavorite(seller.id, e)}
            className="mt-6 p-2 rounded-full hover:bg-gray-100 transition-colors"
          >
            <svg
              className="w-5 h-5"
              fill={favoriteIds.includes(seller.id) ? 'currentColor' : 'none'}
              viewBox="0 0 24 24"
              stroke="currentColor"
              style={{ color: favoriteIds.includes(seller.id) ? '#FF6600' : '#9ca3af' }}
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M5 5h14v14l-7-4-7 4V5z" />
            </svg>
          </button>
        </div>
        <div className="flex items-center gap-2 mt-3 text-xs text-gray-600">
          <img src={seller.countryFlag || 'https://flagcdn.com/w40/ae.png'} alt="" className="w-4 h-4 rounded-sm" />
          <span>
            {seller.country} · {seller.memberYears || 1} yrs
          </span>
        </div>
        <p className="text-xs text-gray-500 mt-1">{seller.businessType}</p>
        <div className="flex gap-4 mt-3 text-xs">
          <button type="button" className="text-b2b-orange font-medium hover:underline" onClick={(e) => { e.stopPropagation(); navigate(`/seller/${seller.id}?tab=reviews`); }}>
            {seller.reviews || 0} reviews
          </button>
          <button type="button" className="text-b2b-orange font-medium hover:underline" onClick={(e) => { e.stopPropagation(); navigate(`/supplier/${seller.id}/products`); }}>
            {productCount} products
          </button>
        </div>
      </div>
    </article>
  );
}
